/**
 * Register block entry.
 *
 * Importing the SCSS here makes Vite bundle the block's CSS alongside its JS.
 * Password show/hide toggle plus a client-side "passwords match" check
 * (server-side validation in inc/wholesale-registration.php remains authoritative).
 */

import './index.scss';

const registers = document.querySelectorAll('.register');

if (registers.length) {
	const passwordToggles = document.querySelectorAll('[data-register-password-toggle]');

	passwordToggles.forEach((toggle) => {
		const field = toggle.closest('.register__password');
		const input = field?.querySelector('input');

		if (!input) return;

		const showIcon = toggle.querySelector('.register__eye-icon--show');
		const hideIcon = toggle.querySelector('.register__eye-icon--hide');

		toggle.addEventListener('click', () => {
			const isVisible = input.type === 'text';

			input.type = isVisible ? 'password' : 'text';
			toggle.setAttribute('aria-pressed', String(!isVisible));
			toggle.setAttribute(
				'aria-label',
				isVisible ? toggle.dataset.labelShow : toggle.dataset.labelHide
			);
			showIcon?.toggleAttribute('hidden', !isVisible);
			hideIcon?.toggleAttribute('hidden', isVisible);
		});
	});

	const registerForm = document.querySelector('.register__form');

	// Strips anything that isn't a digit as the shopper types — the field's
	// pattern/maxlength (template-parts/register/render.php) only reject on
	// submit, so this catches it live instead.
	const nipInput = registerForm?.querySelector('#reg_billing_nip');
	const nipError = registerForm?.querySelector('[data-nip-error]');
	const termsCheckbox = registerForm?.querySelector('#reg_terms');
	const submitButton = registerForm?.querySelector('.register__submit');

	// Same weighted-checksum algorithm as
	// \Theme\WholesaleRegistration\is_valid_nip() (inc/wholesale-registration.php)
	// — client-side mirror so an obviously fabricated NIP (right length,
	// wrong checksum) never even reaches the server-only round trip that
	// silently reloaded the empty form with no explanation.
	const isValidNip = (nip) => {
		if (!/^\d{10}$/.test(nip)) return false;

		const weights = [6, 5, 7, 2, 3, 4, 5, 6, 7];
		const sum = weights.reduce(
			(total, weight, index) => total + weight * Number(nip[index]),
			0
		);

		return sum % 11 === Number(nip[9]);
	};

	if (nipInput && nipError && termsCheckbox && submitButton) {
		const updateSubmitState = () => {
			const nipValid = isValidNip(nipInput.value);

			nipError.hidden = nipValid || nipInput.value === '';
			nipInput.setAttribute('aria-invalid', String(!nipValid));
			submitButton.disabled = !nipValid || !termsCheckbox.checked;
		};

		nipInput.addEventListener('input', () => {
			nipInput.value = nipInput.value.replace(/\D/g, '').slice(0, 10);
			updateSubmitState();
		});

		termsCheckbox.addEventListener('change', updateSubmitState);

		updateSubmitState();
	}

	const password = registerForm?.querySelector('#reg_password');
	const passwordConfirm = registerForm?.querySelector('#reg_password_2');

	if (password && passwordConfirm) {
		const validateMatch = () => {
			const mismatch = passwordConfirm.value !== password.value;
			passwordConfirm.setCustomValidity(
				mismatch ? passwordConfirm.dataset.mismatchMessage : ''
			);
		};

		password.addEventListener('input', validateMatch);
		passwordConfirm.addEventListener('input', validateMatch);
	}
}
